/* eslint-disable no-nested-ternary */
import React from 'react';

import { withRouter } from 'react-router-dom';
import PopOverMenu from '../../../../PopOverMenu';
import { SortType } from '../../../../ColumnHeader';
import withStatsig from '../../../../hocs/withStatsig';

import styles from '../../../../../pages/ClubProfiles/club.scss';
import { getClickAttrs } from '../../../../Analytics/gtag';
import { useStatsig } from '../../../../hooks/useStatsig';

const MembersTabTitleLayout = (props) => {
    const {
        isAdminOrOwner,
        isCollegeOrHighSchool,
        isCollege,
        isHighSchool,
        membersTabState,
        clubDetails,
        clubType,
        user,
    } = props;

    const {
        adminViewType,
        memberViewType,
        requestViewType,
        inviteViewType,
    } = membersTabState;

    const adminMenuItems = [
        {
            label: 'Members',
            value: 'members',
        },
        {
            label: 'Requests',
            value: 'requests',
            show: !isCollegeOrHighSchool,
        },
        {
            label: 'Invites',
            value: 'invites',
            show: !isCollegeOrHighSchool,
        },
    ];
    const memberMenuItems = [
        {
            label: 'Current',
            value: 'current',
        },
        // {
        //     label: 'Former',
        //     value: 'former',
        // },
    ];
    const requestMenuItems = [
        {
            label: 'Pending',
            value: 'Pending',
        },
        {
            label: 'Accepted',
            value: 'Accepted',
        },
        {
            label: 'Rejected',
            value: 'Rejected',
        },
    ];
    const inviteMenuItems = [
        {
            label: 'Pending',
            value: 'pending',
        },
        {
            label: 'Accepted',
            value: 'accepted',
        },
    ];

    const { checkGate, featureGates } = useStatsig();
    const directAddClubMembersEnabled = checkGate(featureGates.DIRECT_ADD_CLUB_MEMBERS);
    const showExportAllMembersButton = isAdminOrOwner && checkGate(featureGates.EXPORT_MEMBERS, user) && (clubDetails.isEnterprise || clubDetails.isPro || clubDetails.isPremium);

    const MemberMenuOptions = () => {
        switch (adminViewType) {
            case 'members':
                return (
                    <div className="border-left ml16 pl16 d-inline-block">
                        <PopOverMenu
                            anchorClass={`${styles.anchorClass}`}
                            menuItems={memberMenuItems}
                            onSelected={(menuItem) => {
                                membersTabState.memberViewType = menuItem.value;
                                props.updateMembersTabState(membersTabState);
                            }}
                            alignLeft={true}
                            data-testid="club-profile.members.member-filter-menu"
                        >
                            <h6 className="text-uppercase mt0 mb0 pl8">
                                {memberViewType}
                                <i className={`${styles.arrow} uts uts-expand`} />
                            </h6>
                        </PopOverMenu>
                    </div>
                );
            case 'requests':
                return (
                    <div className="border-left ml16 pl16 d-inline-block">
                        <PopOverMenu
                            anchorClass={`${styles.anchorClass}`}
                            menuItems={requestMenuItems}
                            onSelected={(menuItem) => {
                                membersTabState.requestViewType = menuItem.value;
                                props.updateMembersTabState(membersTabState);
                            }}
                            alignLeft={true}
                            data-testid="club-profile.members.requests-filter-menu"
                        >
                            <h6 className="text-uppercase mt0 mb0 pl8" data-testid="club-profile.members.request-filter-label">
                                {requestViewType}
                                <i className={`${styles.arrow} uts uts-expand`} />
                            </h6>
                        </PopOverMenu>
                    </div>
                );
            case 'invites':
                return (
                    <div className="border-left ml16 pl16 d-inline-block">
                        <PopOverMenu
                            anchorClass={`${styles.anchorClass}`}
                            menuItems={inviteMenuItems}
                            onSelected={(menuItem) => {
                                membersTabState.inviteViewType = menuItem.value;
                                props.updateMembersTabState(membersTabState);
                            }}
                            alignLeft={true}
                            data-testid="club-profile.members.invites-filter-menu"
                        >
                            <h6 className="text-uppercase mt0 mb0 pl8">
                                {inviteViewType}
                                <i className={`${styles.arrow} uts uts-expand`} />
                            </h6>
                        </PopOverMenu>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div>
            <h6 className={`${styles.titleContainer} row`}>
                <div className={`col-12 col-md-6`}>
                    {isAdminOrOwner ? (
                        <div className="d-inline-block">
                            <PopOverMenu
                                anchorClass={!isCollegeOrHighSchool ? styles.anchorClass : ''}
                                menuItems={adminMenuItems}
                                onSelected={(menuItem) => {
                                    membersTabState.adminViewType = menuItem.value;
                                    membersTabState.sortParam = 'name';
                                    membersTabState.sortType = SortType.ASC;
                                    props.updateMembersTabState(membersTabState);
                                }}
                                alignLeft={true}
                                data-testid="club-profile.members.admin-view-menu"
                            >
                                <h6 className="text-uppercase mt0 mb0 pl8">
                                    {adminViewType === 'members' ? (isCollegeOrHighSchool ? 'Community Members' : 'Members') : adminViewType}
                                    {!isCollegeOrHighSchool && (
                                        <i className={`${styles.arrow} uts uts-expand`} />
                                    )}
                                </h6>
                            </PopOverMenu>
                        </div>
                    ) : isCollegeOrHighSchool ? 'Community Members' : 'Members'}
                    {isAdminOrOwner ? <MemberMenuOptions /> : null}
                </div>
                <div className={`col-12 col-md-6 ${styles.titleButtons}`}>
                    {(isAdminOrOwner && !isHighSchool && directAddClubMembersEnabled) && (
                        <button
                            type="button"
                            className={`btn btn-primary btn-sm ml12 mb12`}
                            data-testid="club-profile.members.add-members-btn"
                            onClick={() => {
                                props.history.push(`/${clubType}/${clubDetails.id}/add-members`);
                            }}
                        >
                            Add {isCollegeOrHighSchool ? 'Community Members' : 'Members'}
                        </button>
                    )}
                    {isAdminOrOwner && (clubDetails.isEnterprise || clubDetails.isPro || isCollege || clubDetails.isPremium) && (
                        <React.Fragment>
                            <button
                                type="button"
                                className={`btn btn-primary btn-sm ml12 mb12`}
                                data-testid="club-profile.members.invite-members-btn"
                                onClick={() => {
                                    props.showInviteMembersModal();
                                }}
                                {...getClickAttrs({
                                    category: 'Invite members',
                                    context: `Invite members button`,
                                    location: 'Club Profile Members Tab CTA',
                                })}
                            >
                                Invite Members
                            </button>

                        </React.Fragment>
                    )}
                    {showExportAllMembersButton && (
                        <React.Fragment>
                            <button
                                type="button"
                                className={`btn btn-primary btn-sm ml12 mb12`}
                                data-testid="club-profile.members.export-members-btn"
                                onClick={props.exportMembers}
                            >
                                Export All Members
                            </button>
                        </React.Fragment>
                    )}
                    {isAdminOrOwner && (
                        <button
                            type="button"
                            className={`btn btn-primary btn-sm ml12 mb12`}
                            data-testid="club-profile.members.message-all-btn"
                            onClick={props.showMessagePopUp}
                        >
                            Message All
                        </button>
                    )}
                </div>
            </h6>
        </div>
    );
};
export default withStatsig(withRouter(MembersTabTitleLayout));
